// ============================================================
// ReportRemittance02 — รายงานการจัดเก็บประจำเดือน
// ------------------------------------------------------------
// สร้างเอกสาร PDF ด้วย pdfmake แล้วเปิดในแท็บใหม่ด้วย openPdf()
// ตั้งค่า pdfmake + ฟอนต์ไทย อยู่ที่ documents/pdf.js (ใช้ร่วมกันทุกไฟล์ในโฟลเดอร์นี้)
// ============================================================

import { openPdf } from "../pdf.js";
import { toFixed, format_date, getStorage, replaceText } from "../../shared/index.js";

import "../../assets/css/bootstrap.css";
import "../../shared/config/global.js";

// พิมพ์รายงานจัดเก็บประจำเดือน
async function report_remittance_2(data, start_date) {
  // รวบตัวแปรผลรวมทั้งหมดไว้ใน Object เดียว
  const sums = { water: 0, eq: 0, common: 0, waste: 0, income: 0, other: 0, debt: 0, late: 0, meter: 0, satang: 0, total: 0 };

  // ใช้ flatMap เพื่อกระจาย record_water_list ออกมาและสร้าง Array ของ PDF row ทันที (ลดลูปซ้อนทิ้ง)
  const array = data.flatMap((d) =>
  {
    // NOTE เดิมมี console.log ค้างอยู่ 2 จุด (ทุกใบเสร็จ + ทุกแถว) — ลบออก
    return (d.record_water_list || []).map((item, i) => {
      try{
      const isAct = d.status_bill === 1;
      const satang = i === 0 ? (d.change_satang || 0) : 0;

      let otherSum = 0, debtDiff = 0, rowTotal = 0;

      if(d.transaction_payments?.length > 0) {
        const payment = d.transaction_payments.find(p=>p.record_water_id === item.record_water_id); // สมมติใช้รายการจ่ายแรก (ถ้ามีหลายรายการอาจต้องปรับ logic)
        if(payment) {
          item.water_bill = payment.s_water_bill ? payment.water_bill : 0;
          item.waste_cost = payment.s_waste_cost ? payment.waste_cost : 0;
          item.reduce_debt = payment.s_reduce_debt ? payment.reduce_debt : 0;
          item.other_income = payment.s_other_income ? payment.other_income : 0;
          item.meter_connect_cost = payment.s_meter_connect_cost ? payment.meter_connect_cost : 0;
          item.late_payment = payment.s_late_payment ? payment.late_payment : 0;
          item.fire_cost = payment.s_fire_cost ? payment.fire_cost : 0;
          item.equipment_maintenance_fee = payment.s_equipment_maintenance_fee ? payment.equipment_maintenance_fee : 0;
          item.common_expenses = payment.s_common_expenses ? payment.common_expenses : 0;
          item.cable_cost = payment.s_cable_cost ? payment.cable_cost : 0;
          item.add_debt = payment.s_add_debt ? payment.add_debt : 0;
        }
      }
      

      if (isAct) {
        otherSum = (item.other_income || 0) + (item.fire_cost || 0) + (item.cable_cost || 0);
        // NOTE add_on_add_debt/add_on_reduce_debt เป็นค่าระดับ "ใบเสร็จ" ไม่ใช่ระดับงวด
        //      เดิมบวกเข้าไปทุกงวดของใบเดียวกัน ใบที่รวมหลายงวดยอดจึงเกินเป็นจำนวนเท่าของงวด
        //      ให้ลงแถวแรกของใบเท่านั้น (กติกาเดียวกับปรับเศษ)
        const addOn = i === 0 ? (d.add_on_add_debt || 0) - (d.add_on_reduce_debt || 0) : 0;
        debtDiff = (item.add_debt || 0) - (item.reduce_debt || 0) + addOn;
        rowTotal = (item.water_bill || 0) + (item.equipment_maintenance_fee || 0) + (item.common_expenses || 0) + 
                   (item.waste_cost || 0) + otherSum + debtDiff + (item.late_payment || 0) + 
                   (item.meter_connect_cost || 0) + satang;
      }

      // Helper สำหรับตั้งค่าตัวเลข (ถ้าไม่ได้ Cancel ให้แสดงเลข ถ้า Cancel ให้แสดง 0.00)
      const txt = (val) => isAct && val ? toFixed(val) : "0.00";

      // สะสมยอดรวมท้ายตารางเฉพาะแถวที่ถูกแสดงจริง
      // NOTE เดิมสะสมก่อนเช็ค rowTotal แถวที่ยอดสุทธิเป็น 0 จึงถูกซ่อน แต่ค่ายังไปโผล่ในยอดรวม
      if (isAct && rowTotal) {
        sums.water += item.water_bill || 0;
        sums.eq += item.equipment_maintenance_fee || 0;
        sums.common += item.common_expenses || 0;
        sums.waste += item.waste_cost || 0;
        sums.other += otherSum;
        sums.debt += debtDiff;
        sums.late += item.late_payment || 0;
        sums.meter += item.meter_connect_cost || 0;
        sums.satang += satang;
        sums.total += rowTotal;
      }
      const recDate = d.record_date ? format_date(d.record_date, "dd/mm/yyyy") : "-";
      const createdDate = item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy") : "-";
      if(rowTotal){
      return [
        { text: d.iw_number || "-", alignment: "center" },
        { text: recDate, alignment: "center" },
        { text: isAct ? (item.address_number || item.address || "-") : "ยกเลิก", alignment: "center" },
        { text: item.full_name || "-", alignment: "left" },
        { text: createdDate, alignment: "center" },
        { text: item.unit_used || "0", alignment: "center" },
        { text: txt(item.water_bill), alignment: "right" },
        { text: txt(item.equipment_maintenance_fee), alignment: "right" },
        { text: txt(item.common_expenses), alignment: "right" },
        { text: txt(item.waste_cost), alignment: "right" },
        { text: "0.00", alignment: "right" }, // income (คอลัมน์นี้ค่าดั้งเดิมล็อกไว้ที่ 0)
        { text: txt(otherSum), alignment: "right" },
        { text: txt(debtDiff), alignment: "right" },
        { text: txt(item.late_payment), alignment: "right" },
        { text: txt(item.meter_connect_cost), alignment: "right" },
        { text: txt(satang), alignment: "right" },
        { text: txt(rowTotal), alignment: "right" },
      ];
    }else{
      return null;
    }
    } catch (error) {
      // NOTE เดิม catch แล้วไม่ return — แถวนั้นกลายเป็น undefined
      //      ตัวกรองด้านล่างกรองเฉพาะ null (undefined !== null) จึงหลุดเข้าไปใน PDF แล้วพังทั้งไฟล์
      console.error("Error processing record:", error, "Data:", d, "Item:", item);
      return null;
    }
    })
  }
  );

  const docDefinition = {
    content: [
      { text: getStorage("project_name"), alignment: "left", fontSize: 18, bold: true },
      { text: "รายงานจัดเก็บเงินประจำเดือน " + format_date(start_date, "mmmm yyyy"), alignment: "left", fontSize: 14, bold: true },
      { text: " " },
      {
        table: {
          headerRows: 1,
          widths: ["8.63%", "7.13%", "4.38%", "13.42%", "6.38%", "4.38%", "5.38%", "4.38%", "5.88%", "3.88%", "5.38%", "4.88%", "5.38%", "4.38%", "5.38%", "3.88%", "6.88%"],
          body: [
            [{ text: "เลขที่ใบเสร็จรับเงิน", alignment: "center" }, { text: "วันที่ รับใบเสร็จ", alignment: "center" }, { text: "บ้านเลขที่", alignment: "center" }, { text: "ชื่อ-นามสกุล", alignment: "center" }, { text: "ประจำเดือน", alignment: "center" }, { text: "หน่วยใช้", alignment: "center" }, { text: "ค่าน้ำประปา", alignment: "center" }, { text: "ค่าบริการ", alignment: "center" }, { text: "ค่าส่วนกลาง", alignment: "center" }, { text: "ค่าขยะ", alignment: "center" }, { text: "เงินทุน/รายรับอื่นๆ", colSpan: 2, alignment: "center" }, "", { text: "เพิ่ม/ลดหนี้", alignment: "center" }, { text: "ปรับล่าช้า", alignment: "center" }, { text: "ค่าต่อมิเตอร์", alignment: "center" }, { text: "ปรับเศษ", alignment: "center" }, { text: "รวม (บาท)", alignment: "center" }],
            ...array.filter(Boolean), // กรองแถวว่าง (null/undefined) ออกก่อนใส่ลงใน PDF
            [{ text: "รวมทั้งสิ้น", colSpan: 6, alignment: "left" }, "", "", "", "", "", 
             { text: toFixed(sums.water), alignment: "right" }, { text: toFixed(sums.eq), alignment: "right" }, 
             { text: toFixed(sums.common), alignment: "right" }, { text: toFixed(sums.waste), alignment: "right" }, 
             { text: toFixed(sums.income), alignment: "right" }, { text: toFixed(sums.other), alignment: "right" }, 
             { text: toFixed(sums.debt), alignment: "right" }, { text: toFixed(sums.late), alignment: "right" }, 
             { text: toFixed(sums.meter), alignment: "right" }, { text: toFixed(sums.satang), alignment: "right" }, 
             { text: toFixed(sums.total), alignment: "right" }
            ],
          ],
        },
      },
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 9, lineHeight: 0.9 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
    pageOrientation: "landscape",
  };

  const textDocDefinition = await replaceText(docDefinition);
  openPdf(textDocDefinition, "รายชื่อลูกค้าที่ยังไม่โอนกรรมสิทธิ์ห้องชุด บันทึกโอนถึง วันที่ " + new Date().toISOString() + ".pdf");
}

export { report_remittance_2 };